import { ApplicationElement, html } from '@effectivastudio/lit-components';

import '@effectivastudio/lit-components/components/avatar/element.js';
import '@effectivastudio/lit-components/components/timeago/element.js';
// dot menu

import translations from './translations.js';
import style from './style.lit.css';

/**
 * Comment component - accepts element with comment text.
 *
 * @prop hasParent - True if this comment is a reply to another comment (optional)
 * @prop deleted - If present, renders info that comment is deleted (optional)
 * @prop picture - Senders profile image
 * @prop timestamp - Timestamp when the comment was created
 * @prop userName - Sender's username
 * @prop userUrl - URL to sender's short info page
 * @prop likeCount - Number of likes for this comment (defaults to 0)
 * @prop replyCount - Number of replies to this comment (defaults to 0)
 *
 * @slot default - For comment text
 * @slot menu - For Dot menu
 */

export default class CardComment extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    hasParent: { type: Boolean },
    deleted: { type: Boolean },
    picture: { type: String },
    timestamp: { type: Date },
    userName: { type: String },
    userUrl: { type: String },
    likeCount: { type: Number },
    replyCount: { type: Number },
  };

  constructor() {
    super();
    this.likeCount = 0;
    this.replyCount = 0;
  }

  /** @internal */
  static translations = translations;

  likeHandler() {
    alert('TO DO: Like handler');
  }

  renderLike() {
    return html`
      <button @click=${this.likeHandler} class="like">
        ${this.t('like', { count: this.likeCount })}
      </button>
    `;
  }

  replyHandler() {
    alert('TO DO: Reply handler');
  }

  renderReply() {
    return html`
      <button @click=${this.replyHandler} class="reply">
        ${this.t('reply', { count: this.replyCount })}
      </button>
    `;
  }

  renderCommentDeleted() {
    return html` <p class="deleted">${this.t('comment_was_deleted')}</p> `;
  }

  render() {
    return html`
      <div class="left">
        <ef-avatar
          .picture=${this.picture}
          layout="xs"
          name=${this.userName}></ef-avatar>
      </div>

      <div class="center">
        <header>
          <a href=${this.userUrl}>${this.userName}</a>
          <ef-timeago .timestamp=${this.timestamp}></ef-timeago>
        </header>
        <main>
          ${this.deleted ? this.renderCommentDeleted() : html`<slot></slot>`}
        </main>
        <footer>
          ${this.renderLike()} ${this.hasParent ? null : this.renderReply()}
        </footer>
      </div>

      <div class="right">
        <!-- TO DO: add Dot menu component, temporary slot -->
        <slot name="menu"></slot>
      </div>
    `;
  }
}

CardComment.registerTagName('bu-card-comment');

customElements.get('bu-card-comment') ||
  customElements.define('bu-card-comment', CardComment);
